import _cloneDeep from 'lodash/cloneDeep';

export interface TopicRequest {
  startWeekId: number;
  endWeekId: number;
  topicIds: string[];
  categoryIds: number[];
  subcategoryIds: number[];
  topicGroupIds: string[];
  segmentIds: string[];
  brandIds: number[];
  sortField?: string;
  retailerId?: number;
  dimension?: string;
  topicType?: string;
  resultCount?: number;
  stacklineSkus?: string[];
  topicNameFuzzyFilter?: string;
  topicGroupNameFuzzyFilter?: string;
}

/**
 * Build requests for topic queries, which do not use AdvancedSearch
 */
export class TopicRequestBuilder {
  protected request: TopicRequest;

  constructor(baseRequest?: TopicRequest) {
    this.request = baseRequest
      ? _cloneDeep(baseRequest)
      : {
          startWeekId: null,
          endWeekId: null,
          topicGroupIds: [],
          topicIds: [],
          segmentIds: [],
          subcategoryIds: [],
          categoryIds: [],
          brandIds: [],
          topicNameFuzzyFilter: '',
          topicGroupNameFuzzyFilter: ''
        };
  }

  public clone(): TopicRequestBuilder {
    return new TopicRequestBuilder(_cloneDeep(this.request));
  }

  public setStartWeekId(startWeekId: number): TopicRequestBuilder {
    this.request.startWeekId = startWeekId;
    return this;
  }

  public setEndWeekId(endWeekId: number): TopicRequestBuilder {
    this.request.endWeekId = endWeekId;
    return this;
  }

  public setTopicIds(topicIds: string[]): TopicRequestBuilder {
    this.request.topicIds = topicIds;
    return this;
  }

  public setCategoryIds(categoryIds: number[]): TopicRequestBuilder {
    this.request.categoryIds = categoryIds;
    return this;
  }

  public setSubcategoryIds(subcategoryIds: number[]): TopicRequestBuilder {
    this.request.subcategoryIds = subcategoryIds;
    return this;
  }

  public setTopicGroupIds(topicGroupIds: string[]): TopicRequestBuilder {
    this.request.topicGroupIds = topicGroupIds;
    return this;
  }

  public setSegmentIds(segmentIds: string[]): TopicRequestBuilder {
    this.request.segmentIds = segmentIds;
    return this;
  }

  public setStacklineSkus(stacklineSkus: string[]): TopicRequestBuilder {
    this.request.stacklineSkus = stacklineSkus;
    return this;
  }

  public build(): TopicRequest {
    return this.request;
  }

  public setSortField(sortField: string): TopicRequestBuilder {
    this.request.sortField = sortField;
    return this;
  }

  public setTopicNameFuzzyFilter(topicName: string): TopicRequestBuilder {
    this.request.topicNameFuzzyFilter = topicName;
    return this;
  }

  public setTopicGroupNameFuzzyFilter(topicGroupName: string): TopicRequestBuilder {
    this.request.topicGroupNameFuzzyFilter = topicGroupName;
    return this;
  }

  public apply(builder: (requestBuilder: TopicRequestBuilder) => TopicRequestBuilder): TopicRequestBuilder {
    return builder(this);
  }

  public setRetailerId(retailerId: number): TopicRequestBuilder {
    this.request.retailerId = retailerId;
    return this;
  }

  public setDimension(dimension: string): TopicRequestBuilder {
    this.request.dimension = dimension;
    return this;
  }

  public setTopicType(topicType?: string): TopicRequestBuilder {
    if (!topicType) {
      delete this.request.topicType;
      return this;
    }

    this.request.topicType = topicType;
    return this;
  }

  public setResultCount(resultCount: number): TopicRequestBuilder {
    this.request.resultCount = resultCount;
    return this;
  }

  public setBrandIds(brandIds: number[]): TopicRequestBuilder {
    this.request.brandIds = brandIds;
    return this;
  }
}
